import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'frontbucket.connect.discoveryCardIcon.label',
    description: 'Label for discovery card',
    defaultMessage: 'Level up with an app',
  },
  body: {
    id: 'frontbucket.connect.discoveryCard.body',
    description: 'Description for discovery card body',
    defaultMessage:
      "Looking for more features? We've got some powerful apps for Bitbucket - get insights into your code, customize your workflow, and more.",
  },
  browse: {
    id: 'frontbucket.connect.discoveryCard.browseApps',
    description: 'Label for browsing apps',
    defaultMessage: 'Browse apps',
  },
  spotlightMessage: {
    id: 'frontbucket.connect.discoveryCard.spotlightMessage',
    description: 'Spotlight message after closing the card',
    defaultMessage:
      'If you want to add or manage apps later, just click your profile picture and choose ',
  },
  integrations: {
    id: 'frontbucket.connect.discoveryCard.spotlightMessage.integrations',
    description: 'Integrations',
    defaultMessage: 'Integrations',
  },
  ok: {
    id: 'frontbucket.connect.discoveryCard.okButton',
    description: 'Button to dismiss spotlight message',
    defaultMessage: 'OK',
  },
});
